/**
 * Loading skeleton for analytics tabs
 * Displayed while lazy-loaded tab components are loading
 */
export function LoadingSkeleton() {
  return (
    <div className="p-6">
      {/* Header skeleton */}
      <div className="h-10 bg-gray-300 dark:bg-gray-800 rounded mb-4 animate-pulse" />

      {/* Metrics cards skeleton */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        {[1, 2, 3, 4].map((i) => (
          <div
            key={i}
            className="h-30 bg-gray-300 dark:bg-gray-800 rounded-lg animate-pulse"
            style={{ animationDelay: `${i * 100}ms` }}
          />
        ))}
      </div>

      {/* Chart skeleton */}
      <div className="h-75 bg-gray-300 dark:bg-gray-800 rounded-lg mb-4 animate-pulse" />

      {/* Table skeleton */}
      <div className="h-50 bg-gray-300 dark:bg-gray-800 rounded-lg animate-pulse" />
    </div>
  );
}
